var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.46 10c0 .345-.28.625-.625.625h-5.209v5.208a.625.625 0 0 1-1.25 0v-5.208H4.168a.625.625 0 0 1 0-1.25h5.208V4.167a.625.625 0 0 1 1.25 0v5.208h5.209c.345 0 .625.28.625.625"
})));
export default SvgPlus;